import './LiveTotalTipsSheet.sass';

import React, { FC, useEffect, memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  liveActions,
  liveTotalTipsLoadingStatusSelector,
  liveShowTotalTipsSheetSelector,
  liveTipsTotalSelector,
  liveTipsSelector,
  LiveShowTotalTipsSheetSelector,
} from '$store/live';
import { BottomSheet } from '$uikit/BottomSheet/BottomSheet';
import { AnimatedEmoji, Placeholder, ScrollView } from '$uikit';
import { LiveUserCell } from '$core/Live/LiveUserCell/LiveUserCell';
import { Currency, Loader } from '$shared/components';
import { CurrencyEnum } from '$store/models';
import { useTranslator } from '$hooks';

export const LiveTotalTipsSheetInner: FC = () => {
  const dispatch = useDispatch();
  const status = useSelector(liveTotalTipsLoadingStatusSelector);
  const tips = useSelector(liveTipsSelector);
  const amount = useSelector(liveTipsTotalSelector);
  const t = useTranslator();

  useEffect(() => {
    dispatch(liveActions.getTotalTips({}));
    const getTotalTips = () => dispatch(liveActions.getTotalTips({ skipLoading: true }));
    const interval = setInterval(getTotalTips, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="LiveTotalTipsSheet">
      {status === 'failed' ? (
        <Placeholder title="error" />
      ) : status === 'loading' ? (
        <Loader isWrapped />
      ) : tips.length ? (
        <ScrollView>
          <div className="LiveTotalTipsSheet__amount">
            <Currency amount={amount} currency={CurrencyEnum.EUR} />
          </div>
          {tips.map((tip) => (
            <LiveUserCell
              onClick={() => {
                dispatch(liveActions.showActionsSheet(tip.userId));
              }}
              rightContent={
                <div className="LiveTotalTipsSheet__tipAmount">
                  <Currency amount={tip.eur} currency={CurrencyEnum.EUR} />
                </div>
              }
              userId={tip.userId}
              key={tip.userId}
            />
          ))}{' '}
        </ScrollView>
      ) : (
        <Placeholder
          iconSize={112}
          icon={<AnimatedEmoji loop emoji={'🤲'} />}
          title={t('live_total_tips_sheet_placeholder_title')}
        >
          {t('live_total_tips_sheet_placeholder_desc')}
        </Placeholder>
      )}
    </div>
  );
};

// eslint-disable-next-line react/display-name
export const LiveTotalTipsSheet: FC = memo(() => {
  const active = useSelector(LiveShowTotalTipsSheetSelector);
  const t = useTranslator();
  const dispatch = useDispatch();

  if (!active) return null;

  return (
    <BottomSheet
      title={t('live_total_tips_sheet_title')}
      onClose={() => dispatch(liveActions.setTotalTipsSheet(false))}
    >
      <LiveTotalTipsSheetInner />
    </BottomSheet>
  );
});
